const helper = {
  getIndexFromTable(listItem, item, currentPage, itemsPerPage) {
    return (
      listItem.findIndex(data => data == item) +
      1 +
      (currentPage - 1) * itemsPerPage
    );
  },

  setColorFromString(string) {
    var colors = [
      "#D81B60",
      "#8E24AA",
      "#5E35B1",
      "#3949AB",
      "#1E88E5",
      "#039BE5",
      "#00ACC1",
      "#00897B",
      "#43A047",
      "#7CB342",
      "#F4511E",
      "#6D4C41",
      "#546E7A",
      "#757575"
    ];
    if (string) {
      var hash = 0;
      if (string.length === 0) return "#FFFF";
      for (var i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      hash = ((hash % colors.length) + colors.length) % colors.length;
      return colors[hash];
    }
    return colors[0];
  },

  findRoute(col, name) {
    var i, temp;
    for (i = 0; i < col.length; i++) {
      if (col[i].url == name) {
        return col[i];
      }
      if (col[i].children && col[i].children.length > 0) {
        temp = this.findRoute(col[i].children, name); // store result
        if (temp) {
          // check
          return temp; // return result
        }
      }
    }
    return null;
  },
  checkValue(data) {
    let status = true;
    Object.values(data).forEach(value => {
      if (
        (Array.isArray(value) && value.length > 0) ||
        (!Array.isArray(value) && value != null)
      ) {
        status = false;
      }
    });
    return status;
  }
};

export default helper;
